import React from "react";
import { cn } from "../lib/utils"; // Assuming you have a cn utility for classnames

const SummaryCard = ({
  title,
  value,
  icon,
  iconBgColor,
  isLoading = false,
}) => {
  return (
    <div className="relative w-full sm:w-64 rounded-xl bg-white/5 p-3 sm:p-4 backdrop-blur-xl border border-white/10 overflow-hidden">
      <div className="flex items-center space-x-3 sm:space-x-4">
        <div
          className={cn(
            "flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-lg",
            iconBgColor
          )}
        >
          {icon}
        </div>
        <div>
          <p className="text-xs sm:text-sm font-medium text-gray-300">
            {title}
          </p>
          {isLoading ? (
            <div className="flex items-center space-x-2">
              <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-[#B8460E]"></div>
              <span className="text-base sm:text-lg font-semibold text-gray-400">
                Loading...
              </span>
            </div>
          ) : (
            <p className="text-xl sm:text-2xl font-bold text-white">{value}</p>
          )}
        </div>
      </div>
      {/* Shine effect */}
      <div className="pointer-events-none absolute inset-0 -z-10 rounded-xl bg-[radial-gradient(circle_at_50%_0%,rgba(255,255,255,0.05)_0%,rgba(255,255,255,0)_25%)]"></div>
    </div>
  );
};

export default SummaryCard;
